import { render } from "./PrestasiMengikutDaerah.vue?vue&type=template&id=2fe207cc"
import script from "./PrestasiMengikutDaerah.vue?vue&type=script&lang=js"
export * from "./PrestasiMengikutDaerah.vue?vue&type=script&lang=js"

import "./PrestasiMengikutDaerah.vue?vue&type=style&index=0&id=2fe207cc&lang=css"
import "./PrestasiMengikutDaerah.vue?vue&type=style&index=1&id=2fe207cc&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__